import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Checkmark } from '../../../../../icons';
import { CHECK_CELL_ICON_SIZE } from '../../table.constants';
export function CheckCell(param) {
    let { value, testId } = param;
    if (value !== true) return null;
    return /*#__PURE__*/ _jsx("span", {
        "data-testid": testId,
        children: /*#__PURE__*/ _jsx(Checkmark, {
            size: CHECK_CELL_ICON_SIZE
        })
    });
}
